import * as tslib_1 from "tslib";
import React from 'react';
import Torpedo from '../../Torpedo';
import EditorDeviationReactView from '../Views/Thumb';
import DeviationLink from '../../Duperbrowse/DeviationLink';
import Grid from '../../Grid';
import DaEditorMonoView from '../Views/Mono';
import MediaService from '../../utils/DeviationMediaService';
var DeviationWithPossibleLink = function (props) {
    var deviation = props.deviation, children = props.children;
    if (deviation.isPublished) {
        return (React.createElement(DeviationLink, { deviation: deviation, title: deviation.title, className: "gallery-link" }, children));
    }
    return children;
};
DeviationWithPossibleLink.displayName = 'DeviationWithPossibleLink';
export var Gallery = function (_a) {
    var _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.layout, layout = _c === void 0 ? 777 : _c, width = _a.width, settings = _a.settings, isHtml = _a.isHtml;
    // When we only have 1 item and we are not in comments
    // use the single deviation view instead
    if (data.length === 1 && !settings.showMediaAlwaysSmall) {
        var config = {
            alignment: 'right',
            key: 'single',
            showDescription: false,
            showTitle: false,
            size: 'content',
        };
        return (React.createElement(DaEditorMonoView, { config: config, settings: settings, deviation: data[0], width: width, isHtml: !!isHtml }));
    }
    if (layout === 1) {
        return renderTorpedo(data, width, isHtml);
    }
    return renderGrid(data, settings, isHtml);
};
Gallery.displayName = 'EditorGallery';
function renderGrid(deviations, settings, isHtml) {
    var getId = function (idx) { return deviations[idx].deviationId; };
    var gridStyles = {};
    var breakpoints = [{ maxWidth: 9999, elementWidth: 386, elementHeight: 338 }];
    // Comments force small media
    if (settings && settings.showMediaAlwaysSmall) {
        breakpoints = [{ maxWidth: 9999, elementWidth: 223, elementHeight: 146 }];
        gridStyles = { maxWidth: '685px' };
    }
    return (React.createElement("div", { style: gridStyles, className: "daeditor-square-grid" },
        React.createElement(Grid, { breakpoints: breakpoints, elementCount: deviations.length, spacing: 8, getElementId: getId, renderElement: function (element) { return (React.createElement("div", { key: element.index, style: tslib_1.__assign({}, element.style) },
                React.createElement(DeviationWithPossibleLink, { deviation: deviations[element.index] },
                    React.createElement(EditorDeviationReactView, { isHtml: isHtml, deviation: deviations[element.index], width: element.width, height: element.height, allowPreviewUsage: true })))); } })));
}
function renderTorpedo(deviations, width, isHtml) {
    var container = {
        width: width,
    };
    if (!width || width <= 0) {
        container.width = 780;
    }
    var items = [];
    for (var _i = 0, deviations_1 = deviations; _i < deviations_1.length; _i++) {
        var dev = deviations_1[_i];
        var largest = MediaService.getLargestFullview(dev);
        items.push({
            id: dev.deviationId,
            width: largest.width,
            height: largest.height,
            deviation: dev,
        });
    }
    return (React.createElement("div", { className: "daeditor-torpedo-grid" },
        React.createElement(Torpedo, { layoutConfig: {
                galleryGutter: true,
                itemSpacingDesktop: 4,
                itemSpacingMobile: 4,
            }, items: items, container: container, renderItem: function (props, item, itemStyle) {
                var deviation = item.dto.deviation;
                var itemWidth = item.width, itemHeight = item.height;
                return (React.createElement("div", { className: "daeditor-torpedo-grid-item", key: "torpedo-" + deviation.deviationId, style: tslib_1.__assign({ width: itemWidth, height: itemHeight }, itemStyle) },
                    React.createElement(DeviationWithPossibleLink, { deviation: deviation },
                        React.createElement(EditorDeviationReactView, { isHtml: isHtml, deviation: deviation, width: itemWidth, height: itemHeight, allowPreviewUsage: true }))));
            } })));
}
//# sourceMappingURL=Gallery.js.map